module.exports = __webpack_public_path__ + "audio/voice5.m4a";